import { Anchor, Breadcrumbs, Card, Grid, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import Metadata from '../../components/Metadata';
import Spinner from '../../components/Spinner';
import GuidanceModal from '../../components/UserFlows/guidanceModal';
import WhatsappMessageForm from '../../components/Whatsapp/WhatsappMessageForm';
import { Page } from '../../constants/pageTitles';
import useFetch from '../../helpers/useFetch';
const page = `${Page['whatsappMessage']}`;

const WhatsappMessagesDetailsPage = () => {
  const navigate = useNavigate();
  const fetch = useFetch();
  const location = useLocation();

  const [whatsappMessage, setWhatsappMessage] = useState();
  const [userError, setUserError] = useState();
  const [loadError, setLoadError] = useState();
  const [guidanceShow, setGuidanceShow] = useState(false);
  const [useInAutomation, setUseInAutomation] = useState(false);

  const { accountId, domainId, whatsappMessageId } = useParams();

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/whatsappMessages/${whatsappMessageId}`)
      .then(({ whatsappMessage }) => {
        if (!whatsappMessage) {
          navigate(`/accounts/${accountId}/domains/${domainId}/whatsapp`);
        }

        setWhatsappMessage(whatsappMessage);
      })
      .catch(setLoadError);
  }, [fetch, navigate, accountId, domainId, whatsappMessageId]);

  const update = (whatsappMessage) => {
    setUserError(null);
    return fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/whatsappMessages/${whatsappMessageId}`, {
      method: 'PUT',
      body: JSON.stringify(whatsappMessage),
    })
      .then((redirect) => {
        setGuidanceShow(false);
        redirect && navigate(location.pathname.replace(`/whatsapp/${whatsappMessage.id}/details`, '/whatsapp'));
      })
      .catch(setUserError);
  };

  const del = (cb) => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/whatsappMessages/${whatsappMessage.id}`, {
      method: 'DELETE',
    })
      .then(() => {
        if (typeof cb === 'function') {
          cb();
        }
        navigate(location.pathname.replace(`/whatsapp/${whatsappMessage.id}/details`, '/whatsapp'));
      })
      .catch(setLoadError);
  };

  const showUserFlow = () => {
    setGuidanceShow(true);
    setUseInAutomation(true);
  };

  if (loadError) {
    return <ErrorMessage message={loadError.message} />;
  }

  if (!whatsappMessage) {
    return <Spinner />;
  }

  const breadcrumbItems = [
    { title: 'Home', href: `#/accounts/${accountId}/domains/${domainId}/analytics` },
    { title: page, href: `#/accounts/${accountId}/domains/${domainId}/whatsapp` },
    { title: 'Edit' },
  ].map((item, index) =>
    item.href ? (
      <Anchor href={item.href} key={index}>
        {item.title}
      </Anchor>
    ) : (
      <Text key={index}>{item.title}</Text>
    )
  );

  return (
    <>
      <Metadata title={`${page} | ${whatsappMessage.name} | Edit`} />
      <Breadcrumbs mb="md">{breadcrumbItems}</Breadcrumbs>
      <GuidanceModal
        type="Whatsapp Message"
        redirect={`/accounts/${accountId}/domains/${domainId}/whatsapp`}
        show={guidanceShow}
        elementTypes={['workflows']}
        element={whatsappMessage}
        setShow={() => {
          setGuidanceShow(false);
          setUseInAutomation(false);
        }}
        useInAutomation={useInAutomation}
      />
      <Grid>
        <Grid.Col span={12}>
          <Card withBorder>
            <WhatsappMessageForm
              whatsappMessage={whatsappMessage}
              saveWhatsappMessage={(whatsappMessage) => update(whatsappMessage)}
              deleteWhatsappMessage={(cb) => del(cb)}
              showUserFlow={() => showUserFlow(true)}
              onBack={() => navigate(-1)}
            />
          </Card>
        </Grid.Col>
      </Grid>
      {userError ? (
        <div style={{ textAlign: 'right' }}>
          <ErrorMessage message={userError.message} />
        </div>
      ) : null}
    </>
  );
};

export default WhatsappMessagesDetailsPage;
